// --- 配置 ---
const API_KEY = 'sk_1N9R7H1LNMuNYEZrX0aLQysO';
const API_BASE = 'https://api-b.fotor.com';
const OSS_CONFIG = {
    endpoint: 'https://best-website.oss-us-east-1.aliyuncs.com',
    bucket: 'best-website',
    accessKeyId: 'LTAI5tRmskgUmBB4zKe7fbvz',
    accessKeySecret: 'hla3piHM7PqRlZBRPB2N6nruWRQ7Mt'
};

function canvasToBase64Png(canvas) {
    // 输出 dataURL（包含 "data:image/png;base64,..."）
    return canvas.toDataURL('image/png');
}

// --- 状态 ---
let currentFile = null;

let selectedArtStyleId = null;
let processedImageUrl = '';
let originalCanvasImageData = null; // 保存原始图片数据，用于文本绘制时恢复
let textPosition = { x: null, y: null }; // 文本位置
let currentText = ''; // 当前显示的文本
let isDragging = false; // 是否正在拖拽
let dragOffset = { x: 0, y: 0 }; // 拖拽偏移量
let textRotation = 0; // 文本旋转角度（弧度）
let isRotating = false; // 是否正在旋转
let rotateStartAngle = 0; // 旋转开始时的角度
let canvasHasFocus = false; // canvas 是否获得焦点
const TEXT_WHITE_STROKE_RADIUS = 12;
const TEXT_WHITE_STROKE_LINE_WIDTH = 24;
const IMAGE_WHITE_STROKE_RADIUS = TEXT_WHITE_STROKE_RADIUS * 4;
const IMAGE_WHITE_STROKE_LINE_WIDTH = TEXT_WHITE_STROKE_LINE_WIDTH * 4;

// --- UI 逻辑 ---
const podContainer = document.getElementById('pod-container');
const contentWrapper = document.getElementById('content-wrapper');
const uploadArea = document.getElementById('upload-area');
const fileInput = document.getElementById('file-input');
const previewImg = document.getElementById('preview-img');
const fileName = document.querySelector('.file-name');
const uploadPlaceholder = document.getElementById('upload-placeholder');
const btnSelectProduct = document.getElementById('btn-select-product');
const loadingOverlay = document.getElementById('loading-overlay');
const loadingText = document.getElementById('loading-text');
const loadingSubtext = document.getElementById('loading-subtext');
const progressText = document.getElementById('progress-text');
const progressBarFill = document.getElementById('progress-bar-fill');
const finalResultCanvas = document.getElementById('final-result-img');
const petName = document.getElementById('pet-name');
const addNameBtn = document.querySelector('.add-btn');
const reuploadBtn = document.querySelector('.reupload-btn');
const podScroll = document.querySelector('.pod-scroll');
const backBtn = document.querySelector('.back-btn');


const petNameColor = document.getElementById('pet-name-color');
const colorPreview = document.getElementById('color-preview');
const colorValue = document.getElementById('color-value');

const petStrokeColor = document.getElementById('pet-stroke-color');
const strokeColorPreview = document.getElementById('stroke-color-preview');
const strokeColorValue = document.getElementById('stroke-color-value');


const fontSizeSlider = document.getElementById('font-size-slider');
const fontSizeValue = document.getElementById('font-size-value');

const btnGenerate = document.getElementById('btn-generate');

const podPreviewPlaceholder = document.querySelector('.pod-preview-placeholder');

let originalImageUrl = '';
const beforeImage = document.querySelector('.before-image');
const afterImage = document.querySelector('.after-image');

// 颜色选择器
let textColor = '#0e3475'; // 文本颜色，默认为蓝色
let textFontSize = 0;
let strokeColor = '#ffffff'; // 描边颜色，默认为白色
// 初始化滑块背景
if (fontSizeSlider) {
    const min = fontSizeSlider.min || 0;
    const max = fontSizeSlider.max || 100;
    const val = fontSizeSlider.value;
    const percent = ((val - min) / (max - min)) * 100;
    fontSizeSlider.style.background = `linear-gradient(to right, #0e3475 ${percent}%, #ccc ${percent}%)`;
    textFontSize = fontSizeSlider.value * 5; // 文本大小
}

let petNameText = '';

function toggleTab(tab) {
    if (tab === 'default') {
        podContainer.style.display = 'none';
    } else {
        podContainer.style.display = 'block';
    }
}

uploadArea.addEventListener('click', (event) => {
    if (event.target.closest('.reupload-btn')) return;
    fileInput.click();
});


if (reuploadBtn) {
    reuploadBtn.addEventListener('click', (event) => {
        event.stopPropagation();
        fileInput.click();
    });
}

btnGenerate.addEventListener('click', handleProcess);


if (btnSelectProduct) {
    // btnSelectProduct.addEventListener('click', uploadToOss);
    btnSelectProduct.addEventListener('click', saveToLocal);
}

// 颜色选择器事件处理
if (petNameColor) {
    // 初始化颜色预览
    updateColorDisplay(textColor);
    
    petNameColor.addEventListener('input', (event) => {
        const newColor = event.target.value.toUpperCase();
        textColor = newColor;
        updateColorDisplay(newColor);
        
        // 如果当前有文本，立即更新显示
        if (currentText && finalResultCanvas.width > 0 && finalResultCanvas.height > 0) {
            drawTextOnCanvas(finalResultCanvas, currentText, textPosition.x, textPosition.y, textRotation);
        }
    });
}

// 新颜色选择逻辑 (Swatches)
const colorSwatches = document.querySelectorAll('.color-swatch');
if (colorSwatches.length > 0) {
    // 初始化颜色：如果有默认选中的，覆盖 textColor
    const activeSwatch = document.querySelector('.color-swatch.active');
    if (activeSwatch) {
        textColor = activeSwatch.style.backgroundColor;
    }

    colorSwatches.forEach(swatch => {
        swatch.addEventListener('click', () => {
            // 1. 移除其他 active
            colorSwatches.forEach(s => s.classList.remove('active'));
            // 2. 选中当前
            swatch.classList.add('active');
            
            // 3. 更新颜色
            textColor = swatch.style.backgroundColor;
            
            // 4. 重绘
            if (currentText && finalResultCanvas.width > 0 && finalResultCanvas.height > 0) {
                drawTextOnCanvas(finalResultCanvas, currentText, textPosition.x, textPosition.y, textRotation);
            }
        });
    });
}

if (petStrokeColor) {
    updateStrokeColorDisplay(strokeColor);
    petStrokeColor.addEventListener('input', (event) => {
        const newColor = event.target.value.toUpperCase();
        strokeColor = newColor;
        updateStrokeColorDisplay(strokeColor);
    });
}


if (fontSizeSlider) {
    fontSizeSlider.addEventListener('input', (event) => {
        const newSize = parseInt(event.target.value, 10);
        textFontSize = newSize * 5;
        
        // 更新滑块背景进度
        const min = event.target.min || 0;
        const max = event.target.max || 100;
        const percent = ((newSize - min) / (max - min)) * 100;
        event.target.style.background = `linear-gradient(to right, #0e3475 ${percent}%, #ccc ${percent}%)`;
        
        if (fontSizeValue) {
            fontSizeValue.textContent = newSize;
        }

        // 如果当前有文本，立即更新显示
        if (currentText && finalResultCanvas.width > 0 && finalResultCanvas.height > 0) {
             drawTextOnCanvas(finalResultCanvas, currentText, textPosition.x, textPosition.y, textRotation);
        }
    });
}

// 更新颜色显示
function updateColorDisplay(color) {
    if (colorPreview) {
        colorPreview.style.backgroundColor = color;
    }
    if (colorValue) {
        colorValue.textContent = color;
    }
}

function updateStrokeColorDisplay(color) {
    if (strokeColorPreview) {
        strokeColorPreview.style.backgroundColor = color;
    }
    if (strokeColorValue) {
        strokeColorValue.textContent = color;
    }
}


addNameBtn.addEventListener('click', (event) => {
    const text = petName.value.trim();
    console.log(text);
    if (finalResultCanvas.width > 0 && finalResultCanvas.height > 0) {
        if (text) {
            // 有文本时，保存文本并绘制
            const isNewText = currentText !== text; // 检查是否是新文本
            currentText = text;
            // 如果是新文本，重置位置到中心和旋转角度
            if (textPosition.x === null || textPosition.y === null || isNewText) {
                textPosition.x = finalResultCanvas.width / 2;
                textPosition.y = finalResultCanvas.height / 2;
                textRotation = 0; // 新文本时重置旋转角度
            }
            drawTextOnCanvas(finalResultCanvas, text, textPosition.x, textPosition.y, textRotation);
        } else {
            // 无文本时，清除文本、位置和旋转角度
            currentText = '';
            textPosition.x = null;
            textPosition.y = null;
            textRotation = 0;
            if (originalCanvasImageData) {
                // 恢复原始图片
                const ctx = finalResultCanvas.getContext('2d');
                ctx.putImageData(originalCanvasImageData, 0, 0);
            }
        }
    }
});

// 添加 canvas 拖拽和旋转功能
finalResultCanvas.addEventListener('mousedown', (event) => {
    const pos = getCanvasMousePos(finalResultCanvas, event);
    
    if (currentText) {
        // 优先检查是否点击在旋转控制点上
        if (isPointOnRotationHandle(finalResultCanvas, pos.x, pos.y)) {
            isRotating = true;
            // 计算初始角度
            rotateStartAngle = getAngleFromCenter(textPosition.x, textPosition.y, pos.x, pos.y) - textRotation;
            finalResultCanvas.style.cursor = 'crosshair';
            event.preventDefault();
            finalResultCanvas.focus(); // 确保 canvas 获得焦点
            return;
        } else if (isPointInText(finalResultCanvas, pos.x, pos.y, currentText)) {
            // 检查是否点击在文本上（拖拽）
            isDragging = true;
            dragOffset.x = pos.x - textPosition.x;
            dragOffset.y = pos.y - textPosition.y;
            finalResultCanvas.style.cursor = 'grabbing';
            event.preventDefault();
            finalResultCanvas.focus(); // 确保 canvas 获得焦点
            return;
        }
    }
    
    // 如果点击的不是文本或控制点，让 canvas 获得焦点
    finalResultCanvas.focus();
});

finalResultCanvas.addEventListener('mousemove', (event) => {
    if (!currentText) return;
    
    const pos = getCanvasMousePos(finalResultCanvas, event);
    
    if (isRotating) {
        // 计算新的旋转角度
        const currentAngle = getAngleFromCenter(textPosition.x, textPosition.y, pos.x, pos.y);
        textRotation = currentAngle - rotateStartAngle;
        // 重绘文本
        drawTextOnCanvas(finalResultCanvas, currentText, textPosition.x, textPosition.y, textRotation);
    } else if (isDragging) {
        // 更新文本位置
        textPosition.x = pos.x - dragOffset.x;
        textPosition.y = pos.y - dragOffset.y;
        // 重绘文本
        drawTextOnCanvas(finalResultCanvas, currentText, textPosition.x, textPosition.y, textRotation);
    } else {
        // 检查鼠标位置，改变光标样式
        if (isPointOnRotationHandle(finalResultCanvas, pos.x, pos.y)) {
            finalResultCanvas.style.cursor = 'crosshair';
        } else if (isPointInText(finalResultCanvas, pos.x, pos.y, currentText)) {
            finalResultCanvas.style.cursor = 'grab';
        } else {
            finalResultCanvas.style.cursor = 'default';
        }
    }
});

finalResultCanvas.addEventListener('mouseup', (event) => {
    if (isDragging) {
        isDragging = false;
        finalResultCanvas.style.cursor = 'default';
    }
    if (isRotating) {
        isRotating = false;
        finalResultCanvas.style.cursor = 'default';
    }
});

finalResultCanvas.addEventListener('mouseleave', (event) => {
    if (isDragging) {
        isDragging = false;
        finalResultCanvas.style.cursor = 'default';
    }
    if (isRotating) {
        isRotating = false;
        finalResultCanvas.style.cursor = 'default';
    }
});

// 添加触摸事件支持（移动端）
finalResultCanvas.addEventListener('touchstart', (event) => {
    event.preventDefault(); // 防止页面滚动
    const pos = getCanvasMousePos(finalResultCanvas, event);
    
    if (currentText) {
        // 优先检查是否点击在旋转控制点上
        if (isPointOnRotationHandle(finalResultCanvas, pos.x, pos.y)) {
            isRotating = true;
            // 计算初始角度
            rotateStartAngle = getAngleFromCenter(textPosition.x, textPosition.y, pos.x, pos.y) - textRotation;
            finalResultCanvas.focus(); // 确保 canvas 获得焦点
            return;
        } else if (isPointInText(finalResultCanvas, pos.x, pos.y, currentText)) {
            // 检查是否点击在文本上（拖拽）
            isDragging = true;
            dragOffset.x = pos.x - textPosition.x;
            dragOffset.y = pos.y - textPosition.y;
            finalResultCanvas.focus(); // 确保 canvas 获得焦点
            return;
        }
    }
    
    // 如果点击的不是文本或控制点，让 canvas 获得焦点
    finalResultCanvas.focus();
});

finalResultCanvas.addEventListener('touchmove', (event) => {
    event.preventDefault(); // 防止页面滚动
    if (!currentText) return;
    
    const pos = getCanvasMousePos(finalResultCanvas, event);
    
    if (isRotating) {
        // 计算新的旋转角度
        const currentAngle = getAngleFromCenter(textPosition.x, textPosition.y, pos.x, pos.y);
        textRotation = currentAngle - rotateStartAngle;
        // 重绘文本
        drawTextOnCanvas(finalResultCanvas, currentText, textPosition.x, textPosition.y, textRotation);
    } else if (isDragging) {
        // 更新文本位置
        textPosition.x = pos.x - dragOffset.x;
        textPosition.y = pos.y - dragOffset.y;
        // 重绘文本
        drawTextOnCanvas(finalResultCanvas, currentText, textPosition.x, textPosition.y, textRotation);
    }
});

finalResultCanvas.addEventListener('touchend', (event) => {
    event.preventDefault();
    if (isDragging) {
        isDragging = false;
    }
    if (isRotating) {
        isRotating = false;
    }
});

finalResultCanvas.addEventListener('touchcancel', (event) => {
    event.preventDefault();
    if (isDragging) {
        isDragging = false;
    }
    if (isRotating) {
        isRotating = false;
    }
});

// 设置 canvas 可以获得焦点
finalResultCanvas.setAttribute('tabindex', '0');

// 添加 focus 和 blur 事件监听器
finalResultCanvas.addEventListener('focus', (event) => {
    canvasHasFocus = true;
    // 如果有文本，重绘以显示控制点
    if (currentText && textPosition.x !== null && textPosition.y !== null) {
        drawTextOnCanvas(finalResultCanvas, currentText, textPosition.x, textPosition.y, textRotation);
    }
});

finalResultCanvas.addEventListener('blur', (event) => {
    canvasHasFocus = false;
    // 重绘以隐藏控制点
    if (currentText && textPosition.x !== null && textPosition.y !== null) {
        drawTextOnCanvas(finalResultCanvas, currentText, textPosition.x, textPosition.y, textRotation);
    }
});

function handleFileSelect(event) {
    const file = event.target.files[0];
    if (!file) return;

    // 检查文件类型：只允许 JPG 和 PNG
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    if (!allowedTypes.includes(file.type.toLowerCase())) {
        alert('Please upload a JPG or PNG image file');
        return;
    }

    // 检查文件大小：最大 10MB
    const maxSize = 10 * 1024 * 1024; // 10MB in bytes
    if (file.size > maxSize) {
        alert('File size must be less than 10MB');
        return;
    }

    currentFile = file;
    const reader = new FileReader();
    reader.onload = (e) => {
        originalImageUrl = e.target.result;
        beforeImage.src = originalImageUrl;
        beforeImage.style.display = 'block';
        fileName.textContent = file.name;
        // previewImg.src = e.target.result;
        // previewImg.style.display = 'block';
        // uploadPlaceholder.style.display = 'none';
        // uploadArea.classList.add('has-image'); // 添加该类名
        if (btnGenerate) {
            btnGenerate.disabled = false;
        }
    };
    reader.onerror = () => {
        alert('Error reading file. Please try again.');
    };
    reader.readAsDataURL(file);
}

// 本地保存图片
async function saveToLocal(url) {
    if (!finalResultCanvas || finalResultCanvas.width === 0 || finalResultCanvas.height === 0) {
        alert('请先生成并预览图像');
        return;
    }
    // 添加 loading 状态
    const originalBtnText = btnSelectProduct.textContent;
    btnSelectProduct.disabled = true;
    btnSelectProduct.innerHTML = '<span class="loading-spinner"></span> Adding...';
    // 先去除水印
    removeWatermark();
    // finalResultCanvas 转 base64 并存储到 IndexedDB（通过 Web Worker）
    try {
        const dataUrl = canvasToBase64Png(finalResultCanvas);
        const record = {
            dataUrl,
            createdAt: Date.now(),
            meta: {
                type: 'image/png',
                width: finalResultCanvas.width,
                height: finalResultCanvas.height
            }
        };
        // 写入 latest（覆盖） + 同时写入一个历史 key
        await window.POD_IDB.put('latest', record);
        await window.POD_IDB.put(`img_${record.createdAt}`, record);
        // 给其他页面一个快速入口：读取 latest
        localStorage.setItem('podLatestSavedAt', String(record.createdAt));

        // 跳转到新的产品页面
        window.location.href = '/products/pod?view=pod-product';
    } catch (e) {
        console.error(e);
        alert(`保存失败：${e.message || e}`);
    } finally {
        // 恢复按钮状态
        btnSelectProduct.disabled = false;
        btnSelectProduct.textContent = originalBtnText;
    }
}

// 说明：全站读取能力已由 layout/theme.liquid 引入的 assets/idb-client.js 提供：
// - window.POD_IDB
// - window.POD_IMAGE_STORE

// 上传到阿里云oss
async function uploadToOss() {
    if (!finalResultCanvas || finalResultCanvas.width === 0 || finalResultCanvas.height === 0) {
        alert('请先生成并预览图像');
        return;
    }

    // 添加 loading 状态
    const originalBtnText = btnSelectProduct.textContent;
    btnSelectProduct.disabled = true;
    btnSelectProduct.innerHTML = '<span class="loading-spinner"></span> Adding...';
    // 先去除水印
    removeWatermark();
    try {
        const blob = await canvasToBlob(finalResultCanvas);
        const fileName = `cartoon-${Date.now()}.png`;
        const objectPath = `/${OSS_CONFIG.bucket}/${fileName}`;
        const url = `${OSS_CONFIG.endpoint}/${fileName}`;
        const method = 'PUT';
        const contentType = 'image/png';
        const date = new Date().toUTCString();
        const canonicalizedHeaders = `x-oss-date:${date}\n`;

        const stringToSign = [
            method,
            '', // Content-MD5
            contentType,
            date,
            canonicalizedHeaders + objectPath
        ].join('\n');

        const signature = await signString(stringToSign, OSS_CONFIG.accessKeySecret);
        const authorization = `OSS ${OSS_CONFIG.accessKeyId}:${signature}`;

        const res = await fetch(url, {
            method,
            headers: {
                'Content-Type': contentType,
                'x-oss-date': date,
                'Authorization': authorization
            },
            body: blob
        });

        if (!res.ok) {
            const text = await res.text();
            throw new Error(`OSS 上传失败: ${res.status} ${text}`);
        }

        localStorage.setItem('ossUploadedUrl', url);
        
        // 跳转到新的产品页面
        window.location.href = '/products/pod?view=pod-product';
        
        // await addToCart(url);
    } catch (error) {
        console.error(error);
        alert(`上传失败: ${error.message}`);
    } finally {
        // 恢复按钮状态
        btnSelectProduct.disabled = false;
        btnSelectProduct.textContent = originalBtnText;
    }
}

function canvasToBlob(canvas) {
    return new Promise((resolve, reject) => {
        if (canvas.toBlob) {
            canvas.toBlob((blob) => {
                if (blob) resolve(blob);
                else reject(new Error('无法从 canvas 生成图片'));
            }, 'image/png');
        } else {
            try {
                const dataUrl = canvas.toDataURL('image/png');
                const blob = dataUrlToBlob(dataUrl);
                resolve(blob);
            } catch (err) {
                reject(err);
            }
        }
    });
}

function addToCart(url) {
    // 1. 获取必要的参数
    const variantId = window.currentVariantId || document.getElementById('pod-variant-id')?.value;
    const quantity = 1;
    const petName = document.getElementById('pet-name')?.value || '';

    if (!variantId) {
        console.error('Variant ID not found');
        alert('Error: Product variant not found');
        return;
    }

    // 2. 尝试获取 cart-drawer 元素并获取 sections ID
    const cartDrawer = document.querySelector('cart-drawer');
    let sectionsToRender = [];
    
    if (cartDrawer && cartDrawer.getSectionsToRender) {
        sectionsToRender = cartDrawer.getSectionsToRender().map((section) => section.id);
    }

    // 3. 构造 JSON 数据
    const formData = {
        'items': [{
            'id': variantId,
            'quantity': quantity,
            'properties': {
                'Custom_Image': url,
                'Pet_Name': petName
            }
        }]
    };

    // 如果有需要渲染的 sections，加入到请求中
    if (sectionsToRender.length > 0) {
        formData.sections = sectionsToRender;
        formData.sections_url = window.location.pathname;
    }

    // 4. 发送请求
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
        console.log('Added to cart:', data);
        
        // 检查是否有错误
        if (data.status) {
             alert('Failed to add to cart: ' + (data.description || 'Unknown error'));
             return;
        }

        // 成功！
        
        // 1. 立即更新 Header 购物车计数 (使用返回的 item_count)
        const cartCountEl = document.getElementById('CartCount');
        if (cartCountEl && data.item_count !== undefined) {
            cartCountEl.textContent = data.item_count;
            cartCountEl.classList.remove('hide');
        }

        // 2. 尝试调用主题的全局更新函数 (如果有，用于更新免邮条等)
        if (typeof freeShippMsg === 'function') {
            freeShippMsg();
        }

        if (cartDrawer && data.sections) {
            // 完美复用主题逻辑：更新并打开抽屉
            cartDrawer.renderContents(data);
        } else {
            // 如果没有 cart-drawer 或没有返回 sections（降级方案）
            // 尝试触发通用事件
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            
            // 或者简单的跳转/提示
             const cartIcon = document.querySelector('.header__icon--cart') || document.querySelector('a[href="/cart"]');
             if (cartIcon) {
                 cartIcon.click();
             } else {
                window.location.href = '/cart';
             }
        }
    })
    .catch(error => {
        console.error('Error adding to cart:', error);
        alert('Network error adding to cart');
    });
}

function dataUrlToBlob(dataUrl) {
    const arr = dataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
}

async function signString(str, secret) {
    const encoder = new TextEncoder();
    const keyData = encoder.encode(secret);
    const key = await crypto.subtle.importKey(
        'raw',
        keyData,
        { name: 'HMAC', hash: 'SHA-1' },
        false,
        ['sign']
    );
    const signature = await crypto.subtle.sign('HMAC', key, encoder.encode(str));
    return arrayBufferToBase64(signature);
}

function arrayBufferToBase64(buffer) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
}


function updateLoading(text, subtext, progress = null) {
    if (loadingText && text) {
        loadingText.textContent = text;
    }
    if (loadingSubtext && subtext) {
        loadingSubtext.textContent = subtext;
    }
    
    // 更新进度条
    if (progress !== null && progress !== undefined) {
        const progressValue = Math.max(0, Math.min(100, progress)); // 确保在 0-100 之间
        if (progressText) {
            progressText.textContent = Math.round(progressValue) + '%';
        }
        if (progressBarFill) {
            progressBarFill.style.width = progressValue + '%';
        }
    }
}


// --- 业务逻辑 ---

async function handleProcess() {
    loadingOverlay.classList.remove('hidden');
    try {
        // 1. 上传图片（示例中按 fotor.ts 的逻辑转换为 Base64）
        updateLoading('📤 Uploading image...', 'Prepare images for AI processing...', 10);
        const imageUrl = await fileToBase64(currentFile);
        await sleep(500);
        // 2. 先进行卡通化
        const prompt = 'cute cartoon style';
        updateLoading('✂️ Submitting cartoonization task...', 'Connect to the AI server and create a processing task.', 20);

        const cartoonTaskId = await apiImg2Img({
            userImageUrl: imageUrl,
            templateId: selectedArtStyleId,
            // templateId: 0,
            content: prompt,
            strength: 0.5,
            format: 'png'
        });

        updateLoading('✂️ Cartoonization task submitted...', 'Waiting for AI processing...', 30);

        let currentProgress = 50;
        const finalCartoonUrl = await pollTaskResult(cartoonTaskId, () => {
            currentProgress = Math.min(80, currentProgress + 2);
            updateLoading('🎨 Generating Cartoon...', `Processing...`, currentProgress);
        });

        // 3. 对卡通化结果去除背景
        try {
            const removeBgTaskId = await apiRemoveBackground(finalCartoonUrl);
            updateLoading('✂️ Removing Background...', 'Waiting for AI processing... ', 80);
            let currentProgress2 = 80;
            cleanedImageUrl = await pollTaskResult(removeBgTaskId, () => {
                currentProgress2 = Math.min(96, currentProgress2 + 2);
                updateLoading('✂️ Removing Background...', `Waiting for AI processing... `, currentProgress2);
            });
            updateLoading('✂️ Removal Complete...', 'Waiting for AI processing... ', 98);
        } catch (bgError) {

            cleanedImageUrl = await processImageFrontend(finalCartoonUrl);
            updateLoading('✂️ Removing Background...', 'Waiting for AI processing... ', 98);
        }

        const imageForCanvas = cleanedImageUrl || finalCartoonUrl;
        // 缓存结果
        localStorage.setItem('cartoonResultUrl', imageForCanvas);
        updateLoading('🎨 Generating Cartoon...', 'Waiting for AI processing... ', 99);
        await addWhiteStroke(imageForCanvas, finalResultCanvas);

        updateLoading('✅ Cartoon Ready!', 'AI processing complete... ', 100);
        loadingOverlay.classList.add('hidden');

        
    } catch (error) {
        console.error(error);
        alert('Error: ' + error.message);
        loadingOverlay.classList.add('hidden');
    }
}


function addWhiteStroke(imageUrl, targetCanvas = null) {
    // podPreviewPlaceholder.classList.remove('aspect');
    console.log(imageUrl, targetCanvas)
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        
        img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            
            // 1. 确定画布尺寸：固定为 5:4 比例
            // 为了保证清晰度，设定一个较高的基准宽度，比如 3000px
            const BASE_WIDTH = 3000;
            const ASPECT_RATIO = 5 / 4;
            
            canvas.width = BASE_WIDTH;
            canvas.height = BASE_WIDTH / ASPECT_RATIO; // 3000 / 1.25 = 2400px

            // 2. 计算图片绘制尺寸和位置
            // 宽度逻辑：图片目标宽度占画布宽度的 60% (左右各留白 20%)
            const targetImgWidth = canvas.width * 0.6;
            
            // 高度逻辑：保持原图宽高比计算目标高度
            const imgAspectRatio = img.width / img.height;
            const targetImgHeight = targetImgWidth / imgAspectRatio;

            // 位置逻辑：水平居中（其实就是 left 20%），垂直居中
            const startX = (canvas.width - targetImgWidth) / 2;
            const startY = (canvas.height - targetImgHeight) / 2;

            // 绘制原图 (使用计算出的目标宽高，确保图片按比例缩放不拉伸)
            ctx.drawImage(img, startX, startY, targetImgWidth, targetImgHeight);

            // 描边画布
            const strokeCanvas = document.createElement('canvas');
            const strokeCtx = strokeCanvas.getContext('2d');
            
            strokeCanvas.width = canvas.width;
            strokeCanvas.height = canvas.height;

            strokeCtx.globalCompositeOperation = 'source-over';
            drawWhiteOutline(
                strokeCtx,
                (offsetX, offsetY) => strokeCtx.drawImage(img, startX + offsetX, startY + offsetY, targetImgWidth, targetImgHeight),
                IMAGE_WHITE_STROKE_RADIUS
            );

            // 将描边填充为白色（使用合成模式优化性能，替代像素遍历）
            strokeCtx.globalCompositeOperation = 'source-in';
            strokeCtx.fillStyle = strokeColor;
            strokeCtx.fillRect(0, 0, strokeCanvas.width, strokeCanvas.height);
            strokeCtx.globalCompositeOperation = 'source-over'; // 恢复默认

            // 合成：先描边后原图
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(strokeCanvas, 0, 0);
            ctx.drawImage(img, startX, startY, targetImgWidth, targetImgHeight);

            // 绘制水印
            // drawWatermark(ctx, canvas.width, canvas.height); // 移动到最后绘制，确保在文本之上

            const resultDataUrl = canvas.toDataURL('image/png');

            if (targetCanvas) {
                const targetCtx = targetCanvas.getContext('2d');
                const oldWidth = targetCanvas.width;
                const oldHeight = targetCanvas.height;
                targetCanvas.width = canvas.width;
                targetCanvas.height = canvas.height;
                targetCtx.clearRect(0, 0, targetCanvas.width, targetCanvas.height);
                targetCtx.drawImage(canvas, 0, 0);
                
                // 保存原始图片数据，用于后续文本绘制时恢复
                originalCanvasImageData = targetCtx.getImageData(0, 0, targetCanvas.width, targetCanvas.height);
                
                // 如果已有文本，需要调整位置并重绘
                if (currentText) {
                    // 如果 canvas 尺寸改变了，按比例调整文本位置
                    if (oldWidth > 0 && oldHeight > 0 && 
                        (oldWidth !== targetCanvas.width || oldHeight !== targetCanvas.height)) {
                        const scaleX = targetCanvas.width / oldWidth;
                        const scaleY = targetCanvas.height / oldHeight;
                        if (textPosition.x !== null && textPosition.y !== null) {
                            textPosition.x *= scaleX;
                            textPosition.y *= scaleY;
                        }
                    } else if (textPosition.x === null || textPosition.y === null) {
                        // 如果位置未设置，设置为中心
                        textPosition.x = targetCanvas.width / 2;
                        textPosition.y = targetCanvas.height / 2;
                    }
                    // 重绘文本（使用保存的旋转角度）
                    drawTextOnCanvas(targetCanvas, currentText, textPosition.x, textPosition.y, textRotation);
                }

                // 绘制水印 (移动到所有内容绘制之后，确保覆盖在最上层)
                drawWatermark(targetCtx, targetCanvas.width, targetCanvas.height);
            }
            beforeImage.src = originalImageUrl;
            beforeImage.style.display = 'block';
            btnSelectProduct.disabled = false;
            resolve(resultDataUrl);
        };

        img.onerror = () => {
            // 若遇到 CORS 失败，可考虑兜底或加代理
            // 本地调试外链图片时常因缺少代理而报错
            // 该示例直接抛出错误
            reject(new Error('Failed to load image for canvas processing (CORS?)'));
        };

        img.src = imageUrl;
    });
}

// --- API 辅助函数 ---

async function fileToBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

async function apiRequest(endpoint, method, body = null) {
    const url = `${API_BASE}${endpoint}`;
    const options = {
        method: method,
        headers: {
            'Authorization': `Bearer ${API_KEY}`,
            'Content-Type': 'application/json'
        }
    };
    if (body) {
        options.body = JSON.stringify(body);
    }

    const response = await fetch(url, options);
    const data = await response.json();
    
    if (!response.ok) {
        throw new Error(data.msg || `API Error: ${response.status}`);
    }
    return data;
}

async function apiImg2Img(params) {
    const res = await apiRequest('/v1/aiart/img2img', 'POST', {
        content: params.content || "",
        templateId: params.templateId,
        userImageUrl: params.userImageUrl,
        strength: params.strength || 0.5,
        format: params.format || 'jpg'
    });
    
    if (res.code && res.code !== '000') {
         // 有些接口以 '000' 表示成功，也有接口仅靠 HTTP 状态码
         throw new Error(res.msg || 'Img2Img failed');
    }
    return res.data.taskId;
}

async function apiRemoveBackground(imageUrl) {
    const res = await apiRequest('/v1/aiart/backgroundremover', 'POST', {
        userImageUrl: imageUrl,
        action: 'auto'
    });
    
    if (res.code && res.code !== '000') throw new Error(res.msg || 'RemoveBg failed');
    return res.data.taskId;
}

async function apiGetTaskDetail(taskId) {
    return await apiRequest(`/v1/aiart/tasks/${taskId}`, 'GET');
}

async function pollTaskResult(taskId, onProgress) {
    const maxAttempts = 60;
    const interval = 2000;
    
    for (let i = 0; i < maxAttempts; i++) {
        if (onProgress) onProgress(i, maxAttempts);
        
        try {
            const res = await apiGetTaskDetail(taskId);
            const data = res.data;
            
            if (data.status === 1) { // 完成
                 if (data.resultUrl) return data.resultUrl;
                 // 有时结果位于 avatarResult
                 if (data.avatarResult && data.avatarResult.length > 0 && data.avatarResult[0].images.length > 0) {
                     return data.avatarResult[0].images[0].url;
                 }
                 throw new Error('Task completed but no result URL found');
            } else if (data.status === 2) { // 失败
                throw new Error(data.msg);
            }
            
            // 状态 0 表示处理中
        } catch (e) {
            console.warn('Polling error:', e);
            if (e.message.includes('Failed')) throw e;
        }
        
        await sleep(interval);
    }
    throw new Error('Polling timeout');
}

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

// --- Canvas 逻辑（从 Vue 迁移） ---
function drawWhiteOutline(ctx, drawCallback, radius = TEXT_WHITE_STROKE_RADIUS) {
    // 优化：增加步长以减少绘制次数，提升性能
    // 对于大半径描边，1px 的精度是不必要的，使用 2px 或 3px 的步长肉眼难以察觉区别但性能提升显著
    const step = radius > 10 ? 3 : 1;
    
    for (let x = -radius; x <= radius; x += step) {
        for (let y = -radius; y <= radius; y += step) {
            if (Math.hypot(x, y) <= radius) {
                drawCallback(x, y);
            }
        }
    }
}



// 在 canvas 上绘制文本（蓝色字体，白色描边，可指定位置和旋转角度）
function drawTextOnCanvas(canvas, text, x = null, y = null, rotation = null) {
    if (!canvas || !text) return;
    
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    // 如果 canvas 还没有内容，直接返回
    if (canvas.width === 0 || canvas.height === 0) return;
    
    // 如果有保存的原始图片数据，先恢复原始图片
    if (originalCanvasImageData) {
        ctx.putImageData(originalCanvasImageData, 0, 0);
    }
    
    // 设置字体样式（加粗）
    const fontSize = textFontSize;
    ctx.font = `bold ${fontSize}px Arial, sans-serif`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    
    // 计算文本位置（如果未指定，使用保存的位置或 canvas 中心）
    if (x === null || y === null) {
        if (textPosition.x !== null && textPosition.y !== null) {
            x = textPosition.x;
            y = textPosition.y;
        } else {
            x = canvas.width / 2;
            y = canvas.height / 2;
        }
    }
    
    // 保存位置
    textPosition.x = x;
    textPosition.y = y;
    
    // 使用保存的旋转角度或传入的角度
    const angle = rotation !== null ? rotation : textRotation;
    
    // 保存当前 canvas 状态
    ctx.save();
    
    // 移动到文本中心并旋转
    ctx.translate(x, y);
    ctx.rotate(angle);
    
    // 绘制白色描边
    ctx.strokeStyle = '#ffffff';
    ctx.lineWidth = TEXT_WHITE_STROKE_LINE_WIDTH;
    ctx.lineJoin = 'round';
    ctx.miterLimit = 2;
    drawWhiteOutline(ctx, (offsetX, offsetY) => ctx.strokeText(text, offsetX, offsetY));
    
    // 绘制文字（在描边之上，加粗，使用选择的颜色）
    ctx.fillStyle = textColor;
    ctx.fillText(text, 0, 0);
    
    // 恢复 canvas 状态
    ctx.restore();

    // 绘制水印 (每次重绘文本后，都需要重新绘制水印覆盖在上面)
    drawWatermark(ctx, canvas.width, canvas.height);
    
    // 绘制旋转控制点（左上角的小圆点）- 只在 canvas 获得焦点时显示
    if (text && canvasHasFocus) {
        drawRotationHandle(ctx, x, y, angle);
    }
}

// 绘制旋转控制点（在文本左上角）
function drawRotationHandle(ctx, centerX, centerY, angle) {
    const fontSize = textFontSize;
    ctx.font = `bold ${fontSize}px Arial, sans-serif`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    
    // 计算文本左上角的位置（考虑旋转）
    const textMetrics = ctx.measureText(currentText);
    const textWidth = textMetrics.width;
    const textHeight = fontSize;
    
    // 文本左上角在未旋转时的相对位置
    const topLeftX = -textWidth / 2;
    const topLeftY = -textHeight / 2;
    
    // 应用旋转变换
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    const rotatedX = topLeftX * cos - topLeftY * sin;
    const rotatedY = topLeftX * sin + topLeftY * cos;
    
    // 转换为 canvas 坐标
    const handleX = centerX + rotatedX;
    const handleY = centerY + rotatedY;
    
    // 绘制控制点（小圆点）
    ctx.save();
    ctx.fillStyle = '#ff4d4f';
    ctx.strokeStyle = '#ffffff';
    ctx.lineWidth = 8;
    ctx.beginPath();
    ctx.arc(handleX, handleY, 24, 0, Math.PI * 2);
    ctx.fill();
    ctx.stroke();
    ctx.restore();
}

// 检测点击是否在文本区域内
function isPointInText(canvas, x, y, text) {
    if (!canvas || !text || textPosition.x === null || textPosition.y === null) return false;
    
    const ctx = canvas.getContext('2d');
    if (!ctx) return false;
    
    const fontSize = textFontSize;
    ctx.font = `bold ${fontSize}px Arial, sans-serif`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    
    // 获取文本的测量信息
    const metrics = ctx.measureText(text);
    const textWidth = metrics.width;
    const textHeight = fontSize;
    
    // 计算文本边界框
    const textX = textPosition.x;
    const textY = textPosition.y;
    const padding = 20; // 增加一些点击区域
    
    // 检查点击是否在文本区域内
    return x >= textX - textWidth / 2 - padding &&
           x <= textX + textWidth / 2 + padding &&
           y >= textY - textHeight / 2 - padding &&
           y <= textY + textHeight / 2 + padding;
}

// 获取 canvas 上的鼠标/触摸坐标（考虑 canvas 的缩放）
function getCanvasMousePos(canvas, event) {
    const rect = canvas.getBoundingClientRect();
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;
    
    // 支持触摸事件
    let clientX, clientY;
    if (event.touches && event.touches.length > 0) {
        clientX = event.touches[0].clientX;
        clientY = event.touches[0].clientY;
    } else if (event.changedTouches && event.changedTouches.length > 0) {
        clientX = event.changedTouches[0].clientX;
        clientY = event.changedTouches[0].clientY;
    } else {
        clientX = event.clientX;
        clientY = event.clientY;
    }
    
    return {
        x: (clientX - rect.left) * scaleX,
        y: (clientY - rect.top) * scaleY
    };
}

// 检测点击是否在旋转控制点上
function isPointOnRotationHandle(canvas, x, y) {
    if (!canvas || !currentText || textPosition.x === null || textPosition.y === null) return false;
    
    const ctx = canvas.getContext('2d');
    if (!ctx) return false;
    
    const fontSize = textFontSize;
    ctx.font = `bold ${fontSize}px Arial, sans-serif`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    
    // 计算文本左上角的位置（考虑旋转）
    const textMetrics = ctx.measureText(currentText);
    const textWidth = textMetrics.width;
    const textHeight = fontSize;
    
    // 文本左上角在未旋转时的相对位置
    const topLeftX = -textWidth / 2;
    const topLeftY = -textHeight / 2;
    
    // 应用旋转变换
    const cos = Math.cos(textRotation);
    const sin = Math.sin(textRotation);
    const rotatedX = topLeftX * cos - topLeftY * sin;
    const rotatedY = topLeftX * sin + topLeftY * cos;
    
    // 转换为 canvas 坐标
    const handleX = textPosition.x + rotatedX;
    const handleY = textPosition.y + rotatedY;
    
    // 检查点击是否在控制点范围内（控制点半径为 36，增加一些点击区域）
    const handleRadius = 45;
    const dx = x - handleX;
    const dy = y - handleY;
    const distance = Math.sqrt(dx * dx + dy * dy);
    
    return distance <= handleRadius;
}

// 计算从文本中心到鼠标位置的角度
function getAngleFromCenter(centerX, centerY, pointX, pointY) {
    return Math.atan2(pointY - centerY, pointX - centerX);
}

// --- 前端兜底逻辑（从 Vue 迁移） ---

function processImageFrontend(imageUrl) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        
        img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            
            canvas.width = img.width;
            canvas.height = img.height;

            // 绘制原图
            ctx.drawImage(img, 0, 0);

            // 读取图像像素数据
            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const data = imageData.data;

            // 简易背景移除（基于边缘色采样）
            const edgeColors = getEdgeColors(data, canvas.width, canvas.height);
            const bgColor = getMostCommonColor(edgeColors);

            // 根据相似颜色去掉背景（设为透明）
            for (let i = 0; i < data.length; i += 4) {
                const r = data[i];
                const g = data[i + 1];
                const b = data[i + 2];

                // 计算与背景色的差异
                const diff = Math.abs(r - bgColor.r) + Math.abs(g - bgColor.g) + Math.abs(b - bgColor.b);
                
                // 若颜色非常接近则设为透明
                if (diff < 100) {
                    data[i + 3] = 0; // Alpha = 0（透明）
                }
            }

            ctx.putImageData(imageData, 0, 0);

            // 添加白色描边（同前）
            const tempCanvas = document.createElement('canvas');
            const tempCtx = tempCanvas.getContext('2d');
            
            tempCanvas.width = canvas.width;
            tempCanvas.height = canvas.height;

            const strokeWidth = 4;
            tempCtx.strokeStyle = '#ffffff';
            tempCtx.lineWidth = strokeWidth;

            for (let x = -strokeWidth; x <= strokeWidth; x++) {
                for (let y = -strokeWidth; y <= strokeWidth; y++) {
                    if (x !== 0 || y !== 0) {
                        tempCtx.drawImage(canvas, x, y);
                    }
                }
            }

            // 合并描边与已经处理过的图像
            tempCtx.drawImage(canvas, 0, 0);

            resolve(tempCanvas.toDataURL('image/png'));
        };

        img.onerror = () => {
            reject(new Error('Failed to load image for frontend processing'));
        };

        img.src = imageUrl;
    });
}

function getEdgeColors(data, width, height) {
    const colors = [];
    
    // 采样上边缘
    for (let x = 0; x < width; x += 10) {
        const i = x * 4;
        colors.push({ r: data[i], g: data[i + 1], b: data[i + 2] });
    }
    
    // 采样下边缘
    for (let x = 0; x < width; x += 10) {
        const i = ((height - 1) * width + x) * 4;
        colors.push({ r: data[i], g: data[i + 1], b: data[i + 2] });
    }
    
    // 采样左边缘
    for (let y = 0; y < height; y += 10) {
        const i = y * width * 4;
        colors.push({ r: data[i], g: data[i + 1], b: data[i + 2] });
    }
    
    // 采样右边缘
    for (let y = 0; y < height; y += 10) {
        const i = (y * width + width - 1) * 4;
        colors.push({ r: data[i], g: data[i + 1], b: data[i + 2] });
    }
    
    return colors;
}

function getMostCommonColor(colors) {
    // 简化处理：返回平均颜色
    const sum = colors.reduce((acc, color) => ({
        r: acc.r + color.r,
        g: acc.g + color.g,
        b: acc.b + color.b
    }), { r: 0, g: 0, b: 0 });

    return {
        r: Math.round(sum.r / colors.length),
        g: Math.round(sum.g / colors.length),
        b: Math.round(sum.b / colors.length)
    };
}


// 绘制水印函数
function drawWatermark(ctx, width, height) {
    const text = "PETOART";
    if (!ctx || !text) {
        console.warn('drawWatermark: ctx or text missing');
        return;
    }

    console.log('drawWatermark start:', width, height, text);

    ctx.save();
    ctx.globalCompositeOperation = 'source-over';
    
    // 设置水印样式
    const fontSize = Math.max(24, Math.floor(Math.min(width, height) / 15)); 
    console.log('Watermark fontSize:', fontSize);
    
    ctx.font = `bold ${fontSize}px Arial, sans-serif`;
    ctx.fillStyle = 'rgba(0, 0, 0, 0.2)'; 
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    
    // 平铺水印
    const rows = 4;
    const cols = 4;
    const stepX = width / cols;
    const stepY = height / rows;
    
    for (let i = 0; i < cols; i++) {
        for (let j = 0; j < rows; j++) {
            const x = i * stepX + stepX / 2;
            const y = j * stepY + stepY / 2;
            
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(-Math.PI / 4); // 旋转 -45 度 (-Math.PI / 4)
            ctx.fillText(text, 0, 0);
            ctx.restore();
        }
    }
    
    ctx.restore();
    console.log('drawWatermark end');
}

// 去除水印函数
function removeWatermark() {
    if (!finalResultCanvas || !originalCanvasImageData) return;
    
    const ctx = finalResultCanvas.getContext('2d');
    
    // 1. 恢复原始图片数据 (包含背景图、卡通图、描边)
    // 这步会覆盖掉画布上所有的内容，包括之前的水印和当前的文本
    ctx.putImageData(originalCanvasImageData, 0, 0);
    
    // 2. 如果当前有文本，需要重新绘制文本
    if (currentText) {
        // drawTextOnCanvas 内部会处理文本绘制，并且我们修改了它的逻辑
        // 它在绘制文本后会自动加上水印，所以为了这里是"去除水印"，
        // 我们需要一种方式只绘制文本不绘制水印，或者直接手动绘制文本逻辑
        
        // 由于 drawTextOnCanvas 已经绑定了强制加水印的逻辑
        // 这里我们可以临时绕过 drawTextOnCanvas，手动重绘一次文本逻辑（不加水印部分）
        // 或者给 drawTextOnCanvas 加个参数控制是否绘制水印，但这会改动已有签名
        
        // 简单方案：手动绘制文本 (复制 drawTextOnCanvas 的核心逻辑但去掉最后一步 drawWatermark)
        
        const fontSize = textFontSize;
        ctx.font = `bold ${fontSize}px Arial, sans-serif`;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        
        let x = textPosition.x;
        let y = textPosition.y;
        
        if (x === null || y === null) {
             x = finalResultCanvas.width / 2;
             y = finalResultCanvas.height / 2;
        }
        
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(textRotation);
        
        // 绘制描边
        ctx.strokeStyle = '#ffffff';
        ctx.lineWidth = TEXT_WHITE_STROKE_LINE_WIDTH;
        ctx.lineJoin = 'round';
        ctx.miterLimit = 2;
        drawWhiteOutline(ctx, (offsetX, offsetY) => ctx.strokeText(currentText, offsetX, offsetY));
        
        // 绘制文字
        ctx.fillStyle = textColor;
        ctx.fillText(currentText, 0, 0);
        
        ctx.restore();
    }
}


// PC端横向滚动拖拽功能
(function() {
    const artStyleGrid = document.querySelector('.art-style-grid');
    if (!artStyleGrid) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    // 鼠标按下
    artStyleGrid.addEventListener('mousedown', (e) => {
        isDown = true;
        artStyleGrid.style.cursor = 'grabbing';
        startX = e.pageX - artStyleGrid.offsetLeft;
        scrollLeft = artStyleGrid.scrollLeft;
    });

    // 鼠标离开
    artStyleGrid.addEventListener('mouseleave', () => {
        isDown = false;
        artStyleGrid.style.cursor = 'grab';
    });

    // 鼠标抬起
    artStyleGrid.addEventListener('mouseup', () => {
        isDown = false;
        artStyleGrid.style.cursor = 'grab';
    });

    // 鼠标移动
    artStyleGrid.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - artStyleGrid.offsetLeft;
        const walk = (x - startX) * 2; // 滚动速度倍数
        artStyleGrid.scrollLeft = scrollLeft - walk;
    });

    // 鼠标滚轮横向滚动
    artStyleGrid.addEventListener('wheel', (e) => {
        if (e.deltaY !== 0) {
            e.preventDefault();
            artStyleGrid.scrollLeft += e.deltaY;
        }
    });
})();

// 艺术风格选项选择功能
(function() {
    const artStyleItems = document.querySelectorAll('.art-style-item');

    // 初始化：获取默认选中项的 data-id
    const activeItem = document.querySelector('.art-style-item.active');
    if (activeItem) {
        selectedArtStyleId = activeItem.getAttribute('data-id');
        console.log('默认选中的艺术风格 ID:', selectedArtStyleId);
    }

    // 为每个选项添加点击事件
    artStyleItems.forEach(item => {
        item.addEventListener('click', function() {
            // 移除所有 active 类
            artStyleItems.forEach(el => el.classList.remove('active'));
            
            // 给当前点击的项添加 active 类
            this.classList.add('active');
            
            // 保存选中项的 data-id
            selectedArtStyleId = this.getAttribute('data-id');
            console.log('选中的艺术风格 ID:', selectedArtStyleId);
            
            // 可以将选中的 ID 保存到全局变量或 localStorage
            window.selectedArtStyleId = selectedArtStyleId;
            if (typeof Storage !== 'undefined') {
                localStorage.setItem('selectedArtStyleId', selectedArtStyleId);
            }
        });
    });

    // 暴露获取选中 ID 的方法
    window.getSelectedArtStyleId = function() {
        return selectedArtStyleId || window.selectedArtStyleId || localStorage.getItem('selectedArtStyleId');
    };
})();

// Before-After 图片加载处理
(function() {
    function handleImageLoad(img) {
        if (!img.src || img.src.trim() === '' || img.src === window.location.href) {
            img.style.display = 'none';
            return;
        }
        
        // 检查图片是否加载成功
        img.onload = function() {
            this.style.display = 'block';
        };
        
        img.onerror = function() {
            this.style.display = 'none';
        };
        
        // 如果图片已经有 src，触发加载检查
        if (img.src && img.src.trim() !== '' && img.src !== window.location.href) {
            img.style.display = 'block';
        } else {
            img.style.display = 'none';
        }
    }
    
    
    if (beforeImage) handleImageLoad(beforeImage);
    
    // 暴露更新图片的方法
    window.updateBeforeAfterImages = function(beforeSrc, afterSrc) {
        if (beforeImage) {
            if (beforeSrc && beforeSrc.trim() !== '') {
                beforeImage.src = beforeSrc;
                beforeImage.style.display = 'block';
            } else {
                beforeImage.src = '';
                beforeImage.style.display = 'none';
            }
        }
        
    };
})();

// Before-After 滑块交互功能
(function() {
    const container = document.getElementById('beforeAfter');
    if (!container) return;

    const slider = document.getElementById('slider');
    const afterImage = container.querySelector('.after-image');
    const afterBackground = container.querySelector('.after-background');
    
    if (!slider || !afterImage || !afterBackground) return;

    let isDragging = false;
    let rafId = null;
    let containerRect = null;

    function updateSlider(position) {
        if (!containerRect) {
            containerRect = container.getBoundingClientRect();
        }
        
        const x = Math.max(0, Math.min(position - containerRect.left, containerRect.width));
        const percentage = (x / containerRect.width) * 100;
        
        slider.style.left = percentage + '%';
        const clipPath = `inset(0 0 0 ${percentage}%)`;
        afterImage.style.clipPath = clipPath;
        afterBackground.style.clipPath = clipPath;
    }

    function handleMove(position) {
        if (rafId) {
            cancelAnimationFrame(rafId);
        }
        
        rafId = requestAnimationFrame(() => {
            updateSlider(position);
        });
    }

    slider.addEventListener('mousedown', (e) => {
        isDragging = true;
        containerRect = container.getBoundingClientRect();
        afterImage.style.transition = 'none';
        afterBackground.style.transition = 'none';
        updateSlider(e.clientX);
        e.preventDefault();
        e.stopPropagation();
    });

    document.addEventListener('mousemove', (e) => {
        if (isDragging) {
            handleMove(e.clientX);
        }
    });

    document.addEventListener('mouseup', () => {
        if (isDragging) {
            isDragging = false;
            containerRect = null;
            if (rafId) {
                cancelAnimationFrame(rafId);
                rafId = null;
            }
        }
    });

    // 触摸事件支持
    slider.addEventListener('touchstart', (e) => {
        isDragging = true;
        containerRect = container.getBoundingClientRect();
        afterImage.style.transition = 'none';
        afterBackground.style.transition = 'none';
        updateSlider(e.touches[0].clientX);
        e.preventDefault();
        e.stopPropagation();
    });

    document.addEventListener('touchmove', (e) => {
        if (isDragging) {
            handleMove(e.touches[0].clientX);
            e.preventDefault();
        }
    });

    document.addEventListener('touchend', () => {
        if (isDragging) {
            isDragging = false;
            containerRect = null;
            if (rafId) {
                cancelAnimationFrame(rafId);
                rafId = null;
            }
        }
    });
})();

// 等待 DOM 加载完成后再执行调试代码
// document.addEventListener('DOMContentLoaded', () => {
//     const cachedUrl = localStorage.getItem('cartoonResultUrl');
//     console.log(1111111111)
//     // addWhiteStroke('https://pub-static.fotor.com/aigc/business/9204505f237f4c0a8ffd2172102c9815/backgroundremover/20251212/248deb2f05ef4a8bbbdb3c5c5752ac9b.png', finalResultCanvas);
//     addWhiteStroke('https://pub-static.fotor.com/aigc/business/9204505f237f4c0a8ffd2172102c9815/backgroundremover/20251218/6b66ed44d16d484aa222c51f9bc38a0a.png', finalResultCanvas);
//     // addWhiteStroke('https://best-website.oss-us-east-1.aliyuncs.com/cartoon-1765269433954.png', finalResultCanvas);
// });